<mat-toolbar>
  <mat-toolbar-row class="sub-toolbar">
    <button
      class="synap-button"
      aria-label="Abrir menú"
      mat-icon-button
      (click)="drawer.toggle()"
      *ngIf="isHandset$ | async">
      <mat-icon aria-hidden="true">menu</mat-icon>
    </button>
    <div class="synap-logo">
      <img class="synap-logo-img" src="assets/img/epago.svg" alt="Epago" />
    </div>
    <div class="doc-search-wrap" role="search">
      <mat-icon class="doc-search-icon" aria-hidden="true">search</mat-icon>
      <input
        class="doc-search-input"
        type="search"
        [matAutocomplete]="docSearchAuto"
        [value]="searchQuery"
        (input)="onSearchInput($any($event.target).value)"
        (keydown.enter)="goToSearchResult()"
        autocomplete="off"
        placeholder="Buscar en docs"
        aria-label="Buscar en documentación" />
      <mat-autocomplete
        #docSearchAuto="matAutocomplete"
        class="doc-search-autocomplete"
        (optionSelected)="onSearchOptionSelected($event.option.value)">
        <mat-option *ngFor="let entry of filteredSearchableEntries" [value]="entry.label">
          {{ entry.label }}
        </mat-option>
      </mat-autocomplete>
      <button class="doc-search-submit" type="button" (click)="goToSearchResult()" aria-label="Ejecutar búsqueda">
        <mat-icon aria-hidden="true">arrow_forward</mat-icon>
      </button>
      <div *ngIf="searchFeedback" class="doc-search-feedback" aria-live="polite">{{ searchFeedback }}</div>
    </div>
    <div class="sub-title">
      <span>Epago — Docs</span>
    </div>
  </mat-toolbar-row>
</mat-toolbar>

<mat-sidenav-container class="sidenav-container" #sidenavContainer>
  <mat-sidenav
    #drawer
    class="sidenav"
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="(isHandset$ | async) === false">
    <mat-nav-list>
      <app-menu-item *ngFor="let menuItem of menuList" [menuItem]="menuItem"></app-menu-item>
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content class="sidenav-content">
    <div class="sidenav-content-layer">
      <router-outlet (activate)="onActivate()"></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
